import { GetExistingLeaseDocumentsResponse } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import applicationFormService from '../../services/applicationForm.service';
import { NetworkError } from '../../state-machine/actions/genericActions';

const getExistingLeaseDocuments = async (orderId: string): Promise<GetExistingLeaseDocumentsResponse> => {
  try {
    const { data } = await applicationFormService.getExistingLeaseDocuments(orderId);
    return data?.getExistingLeaseDocuments as GetExistingLeaseDocumentsResponse;
  } catch (err: any) {
    const error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
        break;
    }
    throw error;
  }
};

export default getExistingLeaseDocuments;
